import { CommonModule } from '@angular/common';
import {
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { StrapiButtonLink } from '../../interfaces/fce-interfaces.index';

@Component({
  standalone: true,
  selector: 'app-button-menu',
  templateUrl: './button-menu.component.html',
  styleUrls: ['./button-menu.component.scss'],
  imports: [CommonModule, RouterModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ButtonMenuComponent implements OnInit {
  @Input() id!: string;
  @Input() ariaLabel?: string;
  @Input() iconName?: string;
  @Input() iconSvg?: string;
  @Input() label?: string;
  @Input() size?: 'small' | 'standard' = 'standard';
  @Input() shape?: 'rounded' | 'squared' = 'rounded';
  @Input() type?: 'label' | 'icon-left' | 'icon-right' | 'icon-only' = 'label';
  @Input() variant?: 'primary' | 'secondary' | 'tertiary' | 'header' = 'primary';
  @Input() theme?: 'light' | 'dark' = 'light';
  @Input() color?: 'basic' | 'danger' | 'input' = 'basic';
  @Input() textWeight?: 'button-light' | 'regular' | 'medium' | 'bold' | 'italic' = 'regular';
  @Input() fullWidth = false;
  @Input() selected: 'notselected' | 'selected' | 'selectednews' = 'notselected';
  @Input() role?: 'button' | 'link' = 'link';

  @Input() url!: string;
  @Input() externalLink = false;

  @Input() strapiButtonLink?: StrapiButtonLink;

  @Output() keyDownEvent = new EventEmitter<KeyboardEvent>();

  getClassObject() {
    return {
      [this.size ?? 'standard']: !!this.size,
      [this.type ?? 'label']: !!this.type,
      [this.variant ?? 'primary']: !!this.variant,
      [this.color ?? 'basic']: !!this.color,
      [this.theme ?? 'light']: !!this.theme,
      [this.shape ?? 'rounded']: !!this.shape,
      [this.textWeight ?? 'regular']: !!this.textWeight,
      [this.selected ?? 'notselected']: !!this.selected,
    };
  }

  getTextAlign(): string {
    return this.type === 'icon-left' ? 'row' : 'row-reverse';
  }

  onKeyUpLink(event: KeyboardEvent) {
    const pressedKey = event.key;

    if (pressedKey === ' ') {
      (event.target as HTMLElement).blur();
      this.router.navigate([this.url]);
    }
  }

  handleKeyDown(event: KeyboardEvent): void {
    this.keyDownEvent.emit(event);
  }

  constructor(private readonly router: Router) {}
  ngOnInit(): void {
    if (this.strapiButtonLink) {
      this.initComponent(this.strapiButtonLink);
    }
  }

  initComponent(strapiButtonLink: StrapiButtonLink) {
    this.label = strapiButtonLink.name;
    this.ariaLabel = strapiButtonLink.ariaLabel;
    this.url = strapiButtonLink.url;
    this.externalLink = strapiButtonLink.isExternal;
    if (this.externalLink) {
      this.iconName = 'open_in_new';
    } else {
      this.iconName = 'arrow_forward';
    }
  }

  removeFocus(event: Event) {
    (event.currentTarget as HTMLElement).blur();
  }
}
